import styled from "styled-components"

export const Container = styled.div`
    flex: auto;

    display: flex;
    align-items: center;
    flex-direction: column;
    overflow-y: auto;

    .chooseDate{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        width: 100%;
        flex: auto;
        margin-bottom: 3rem;

        @media (max-width: 600px) {
           grid-template-columns: 1fr;
        }
    }
`

export const DateTimeInputs = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    input{
        max-height: 60px;
    }

    p{
        font-weight: 500;
        font-size: 1.2rem;
        margin: 0.5rem 1rem;
    }

    &::-webkit-scrollbar-track {
            background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;
`

export const ContentButtons = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-right: 1px solid #DDD;

    @media (max-width: 600px) {
        margin-bottom: 1rem;
        border: none;
    }
`

export const ButtonDate = styled.div`
    width: 100%;
    color: #7A05A7;
    cursor: pointer;
    padding: .4rem;
    font-size: 1.2rem;
    transition: background .25s;
    font-weight: ${props => props.selected ? 'bold' : 'normal'};

    display: flex;
    align-items: center;
    justify-content: center;

    p{
        margin-right: 1rem;
    }

    &:hover{
        background: #F7F7F7;
    }
`